module.exports = __webpack_public_path__ + "images/notifications/join-request-ef4a7960f7b0b215484e43bebea93dfa.png";